import { render } from "./RowTyreDetailSlider.vue?vue&type=template&id=f757de54"
import script from "./RowTyreDetailSlider.vue?vue&type=script&lang=js"
export * from "./RowTyreDetailSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__